import type { FrameDetection } from './onnxInference';

export interface Vehicle {
  make: string;
  model: string;
  year?: string;
}

export interface VehicleInfo {
  make?: string;
  model?: string;
  yearStart?: number;
  yearEnd?: number;
}

export interface MatchProduct {
  id: string;
  category: string;
  name: string;
  imageUrl?: string;
  pricePix: number;
  priceInstallment: number;
  installmentCount: number;
  sourceUrl?: string;
  similarity?: number;
  vehicleMatch?: string;
  vehicleBoost?: number;
  vehicleInfo?: VehicleInfo;
}

export interface PredictionResult {
  category: string;
  confidence: number;
  scores: Record<string, number>;
  matches: MatchProduct[];
}

export interface ZoneDetection {
  zoneIndex: number;
  x: number;
  y: number;
  w: number;
  h: number;
  className: string;
  confidence: number;
  dominant: boolean;
}

export type ScreenId = 'vehicle' | 'upload' | 'ar' | 'results' | 'video' | 'videoresults';

class Session {
  vehicle = $state<Vehicle | null>(null);
  selectedFile = $state<File | null>(null);
  results = $state<PredictionResult | null>(null);
  currentScreen = $state<ScreenId>('vehicle');
  activeDetections = $state<ZoneDetection[]>([]);
  selectedZoneIndex = $state<number | null>(null);
  arScanMode = $state<'idle' | 'scanning' | 'detected' | 'selected'>('idle');
  videoFile = $state<File | null>(null);
  videoUrl = $state<string | null>(null);
  videoDetections = $state<FrameDetection[]>([]);
  videoDuration = $state(0);
  private _history = $state<ScreenId[]>(['vehicle']);

  get history(): ScreenId[] { return this._history; }

  setVehicle(v: Vehicle) { this.vehicle = v; }
  setFile(f: File | null) { this.selectedFile = f; }
  setResults(r: PredictionResult | null) { this.results = r; }
  setActiveDetections(detections: ZoneDetection[]) { this.activeDetections = detections; }
  selectZone(index: number | null) { this.selectedZoneIndex = index; }
  clearDetections() { this.activeDetections = []; this.selectedZoneIndex = null; }
  navigate(screen: ScreenId) {
    this._history.push(screen);
    this.currentScreen = screen;
  }
  goBack(): ScreenId | null {
    if (this._history.length <= 1) return null;
    this._history.pop();
    const prev = this._history[this._history.length - 1] ?? 'upload';
    this.currentScreen = prev;
    return prev;
  }
  setVideoFile(f: File | null) { this.videoFile = f; this.videoUrl = f ? URL.createObjectURL(f) : null; }
  setVideoDetections(d: FrameDetection[]) { this.videoDetections = d; }
  setVideoDuration(d: number) { this.videoDuration = d; }
  clearVideo() { this.videoFile = null; if (this.videoUrl) URL.revokeObjectURL(this.videoUrl); this.videoUrl = null; this.videoDetections = []; }
}

export const session = new Session();
